var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54548 17.1819H5.72729V30.5455H9.54548V17.1819Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 17.1819H17.1818V30.5455H20.9999V17.1819Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1818 9.54545L19.0909 0L0 9.54545V13.3636H38.1818V9.54545Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.3635V38.1817H23.6727C23.2718 36.9599 23.0618 35.6808 22.9855 34.3635H0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4545 21.4964V17.1819H28.6364V23.4055L32.4545 21.4964Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3637 24.8181L26.7273 28.6363V33.5045C26.7273 38.3154 29.9918 42.8208 34.3637 43.909C38.7355 42.8208 42 38.3154 42 33.5045V28.6363L34.3637 24.8181ZM32.9891 38.1818L29.1137 34.3063L31.1373 32.2827L32.9891 34.1345L37.59 29.5908L39.6137 31.6145L32.9891 38.1818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.53206d412a9f97d28d2aacdf13bdc7e8.svg";
export { ForwardRef as ReactComponent };